import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    Card,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Avatar,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    List,
    ListItem,
    ListItemText,
    Button,
    Chip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import StudentCards from "./UserProfileCard";
import StudentService from "./Locality/Service/studentService";
import ActivityService from "./Locality/Service/activityService";

const useStyles = makeStyles((theme) => ({
    pageContainer: {
        maxWidth: 1080,
        margin: "0 auto",
        padding: theme.spacing(3),
        backgroundColor: "#f8fafc",
    },
    studentSelectorCard: {
        borderRadius: 18,
        padding: theme.spacing(1),
        marginBottom: theme.spacing(3),
        background: "#ffffff",
        boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
    },
    heroCard: {
        borderRadius: 24,
        padding: theme.spacing(3.5),
        background: "linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)",
        border: "1px solid #e2e8f0",
        boxShadow: "0 12px 32px rgba(15, 23, 42, 0.08)",
    },
    section: {
        marginTop: theme.spacing(4),
    },
    sectionCard: {
        borderRadius: 20,
        padding: theme.spacing(2.5),
        backgroundColor: "#ffffff",
        boxShadow: "0 10px 28px rgba(15, 23, 42, 0.06)",
    },
    sectionTitle: {
        fontWeight: 800,
        color: "#1e3a8a",
        textAlign: "center",
        marginBottom: theme.spacing(3),
        letterSpacing: 0.4,
    },
    subTitle: {
        fontWeight: 700,
        color: "#0f172a",
        marginBottom: theme.spacing(2),
    },
    tablePaper: {
        overflow: "hidden",
        borderRadius: 16,
        border: "1px solid #e5e7eb",
        boxShadow: "none",
    },
    headCell: {
        fontWeight: 700,
        background: "#eff6ff",
        color: "#1e3a8a",
    },
    bodyCell: {
        color: "#334155",
    },
    profileCard: {
        borderRadius: 16,
    },
    profileAvatar: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    introLabel: {
        color: "#64748b",
        fontWeight: 600,
        marginBottom: theme.spacing(1),
    },
    heroName: {
        fontWeight: 800,
        color: "#ea580c",
        textTransform: "uppercase",
        marginBottom: theme.spacing(2),
    },
    infoGrid: {
        marginBottom: theme.spacing(2),
    },
    infoCard: {
        backgroundColor: "#f8fafc",
        borderRadius: 14,
        padding: theme.spacing(1.5, 2),
        border: "1px solid #e2e8f0",
    },
    infoLabel: {
        color: "#64748b",
        fontSize: "0.8rem",
        marginBottom: theme.spacing(0.5),
    },
    infoValue: {
        color: "#0f172a",
        fontWeight: 700,
    },
    heroDescription: {
        color: "#475569",
        lineHeight: 1.8,
        maxWidth: 620,
    },
    avatarWrap: {
        display: "flex",
        justifyContent: "center",
    },
    heroAvatar: {
        width: 180,
        height: 180,
        border: "6px solid #ffffff",
        boxShadow: "0 12px 32px rgba(37, 99, 235, 0.18)",
        backgroundColor: "#dbeafe",
    },
    statsGrid: {
        marginTop: theme.spacing(3),
    },
    statCard: {
        borderRadius: 16,
        padding: theme.spacing(2),
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        boxShadow: "0 6px 18px rgba(15, 23, 42, 0.05)",
        height: "100%",
    },
    statLabel: {
        color: "#64748b",
        fontSize: "0.85rem",
        marginBottom: theme.spacing(1),
    },
    statValue: {
        color: "#0f172a",
        fontSize: "1.7rem",
        fontWeight: 800,
        lineHeight: 1.1,
    },
    clickableValue: {
        color: "#1d4ed8",
        fontWeight: 700,
        cursor: "pointer",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    emptyState: {
        padding: theme.spacing(4),
        textAlign: "center",
        color: "#64748b",
    },
    dialogList: {
        minWidth: 320,
        padding: 0,
    },
    dialogPaper: {
        borderRadius: 20,
        overflow: "hidden",
    },
    dialogTitle: {
        background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
        color: "#1e3a8a",
        fontWeight: 800,
        padding: theme.spacing(2.5, 3),
        borderBottom: "1px solid #dbeafe",
    },
    dialogSubtitle: {
        color: "#64748b",
        marginBottom: theme.spacing(2),
    },
    dialogContent: {
        padding: theme.spacing(2, 3),
        backgroundColor: "#f8fafc",
    },
    activityItem: {
        backgroundColor: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: 14,
        marginBottom: theme.spacing(1.5),
        padding: theme.spacing(0.5, 1),
        boxShadow: "0 4px 14px rgba(15, 23, 42, 0.04)",
    },
    activityIndex: {
        minWidth: 30,
        height: 30,
        borderRadius: "50%",
        backgroundColor: "#dbeafe",
        color: "#1d4ed8",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        marginRight: theme.spacing(1.5),
        fontSize: "0.85rem",
    },
    activityName: {
        color: "#0f172a",
        fontWeight: 600,
    },
    dialogActions: {
        padding: theme.spacing(1.5, 3, 2.5),
        backgroundColor: "#f8fafc",
        borderTop: "1px solid #e2e8f0",
    },
    closeButton: {
        borderRadius: 10,
        textTransform: "none",
        fontWeight: 700,
        padding: theme.spacing(1, 2.5),
    },
}));

export default function MyStoryPage() {
    const classes = useStyles();
    var [studentId, setStudentId] = useState("");
    var [classId, setClassId] = useState("");
    const [monthWiseAttendance, setMonthWiseAttendance] = useState([]);
    const [activityPerformance, setActivityPerformance] = useState({});
    const [studentEvent, setStudentEvent] = useState({});
    const [activityDialog, setActivityDialog] = useState({
        open: false,
        title: "",
        items: [],
    });
    const [isActivityDialogLoading, setIsActivityDialogLoading] = useState(false);

    const [studentList, setStudentList] = useState([]);
    const [selectedStudentId, setSelectedStudentId] = useState(null);
    useEffect(() => {
        fetchStudentList();

    }, []);
    const [selectedStudent, setSelectedStudent] = useState(null);

    useEffect(() => {
        if (!selectedStudent && studentList.length > 0) {
            const firstStudent = studentList[0];
            const firstClassId =
                firstStudent?.classId?._id || firstStudent?.classId || null;

            if (firstStudent?._id && firstClassId) {
                handleStudentClick(firstStudent._id, firstClassId, firstStudent.dob);
            }
        }
    }, [studentList, selectedStudent]);

    const onStudentSelect = (id, classId) => {
        const student = studentList.find(
            (s) => s._id === id && (s.classId?._id || s.classId) === classId
        );

        if (!student) return;
        const age = calculateAge(student.dob);
        setSelectedStudent({
            ...student,
            age,
        });
    };

    const handleStudentClick = (studentId, classId, dob) => {
        // Update selected student

        setStudentId(studentId);
        setClassId(classId);
        setSelectedStudentId(studentId);
        onStudentSelect(studentId, classId);
        getMonthWiseAttendance(studentId);
        getStudentActivityPerformance(studentId);
        getStudentEvent(studentId, classId);

    };
    const calculateAge = (dob) => {
        if (!dob) return null;
        const birthDate = new Date(dob);
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };
    const getMonthWiseAttendance = (studentId) => {
        const report = JSON.parse(localStorage.getItem("userDetail")) || {};
        const keys = {
            schooleId: report.schooleId || report.schoolId || null,
        };

        StudentService.getStudentAttendanceSummary(studentId, keys)
            .then((res) => {
                setMonthWiseAttendance(Array.isArray(res?.data) ? res.data : []);
            })
            .catch((err) => {
                console.error("Error fetching student attendance summary", err);
                setMonthWiseAttendance([]);
            });
    };

    const getStudentEvent = (studentId) => {
        const report = JSON.parse(localStorage.getItem("userDetail")) || {};
        const keys = {
            schooleId: report.schooleId || report.schoolId || null,
        };

        StudentService.getStudentAssignmentSummary(studentId, keys)
            .then((res) => {
                setStudentEvent(res || {});
            })
            .catch((err) => {
                console.error("Error fetching student assignment summary", err);
                setStudentEvent({
                    submitted: 0,
                    notSubmitted: 0,
                    resubmitSubmitted: 0,
                    resubmitNotSubmitted: 0,
                    total: 0,
                });
            });
    };
    const getStudentActivityPerformance = (studentId) => {
        const report = JSON.parse(localStorage.getItem("userDetail")) || {};
        const keys = {
            schooleId: report.schooleId || report.schoolId || null,
        };

        StudentService.getStudentActivitySummary(studentId, keys)
            .then((res) => {
                setActivityPerformance(res || {});
            })
            .catch((err) => {
                console.error("Error fetching student activity summary", err);
                setActivityPerformance({
                    totalActivities: 0,
                    strongArea: 0,
                    developingArea: 0,
                    needsAction: 0,
                    totalActivityNames: [],
                    strongAreaNames: [],
                    developingAreaNames: [],
                    needsActionNames: [],
                });
            });
    };
    const fetchStudentList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        const body = {};

        if (userDetails.role === "PARENT") {
            body.userId = userDetails._id;
        } else if (userDetails.role === "SCHOOLE" || userDetails.role === "SUPERADMIN") {
            body.schooleId = userDetails.schooleId || userDetails.schoolId;
        } else if (userDetails.role === "TEACHER") {
            body.schooleId = userDetails.schooleId || userDetails.schoolId;
            if (userDetails.classId) body.classId = userDetails.classId;
            if (userDetails.sectionId) body.sectionId = userDetails.sectionId;
        }

        StudentService.findStudentList(body)
            .then((res) => {
                const mappedStudents = (res || []).map((student) => ({
                    ...student,
                    fullName: `${student.firstName || ""} ${student.lastName || ""}`.trim(),
                }));
                setStudentList(mappedStudents);
            })
            .catch((err) => console.error(err));
    };
    // const attendanceRows = [
    //     { month: "Jan", presentDays: 20, absentDays: 2, lateDays: 1 },
    //     { month: "Feb", presentDays: 18, absentDays: 3, lateDays: 0 },
    // ];

    // const activityPerformanceRows = [
    //     { activity: "Drawing", score: "A+" },
    //     { activity: "Reading", score: "A" },
    // ];


    const getMonthName = (monthNumber) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        // monthNumber: 1 for Jan, 12 for Dec
        return monthNames[monthNumber - 1] || "";
    };

    const getActivityNamesFromResponse = (response = []) => {
        const names = [];

        (response || []).forEach((activity) => {
            const parentName = activity?.activityId?.activityName;
            if (parentName) {
                names.push(parentName);
            }

            (activity?.activityRecordsId || []).forEach((record) => {
                const recordName = record?.activityId?.activityName;
                if (recordName) {
                    names.push(recordName);
                }
            });
        });

        return [...new Set(names)];
    };

    const fetchActivityNames = async (keys = []) => {
        const report = JSON.parse(localStorage.getItem("userDetail")) || {};
        const baseBody = {
            schooleId: report.schooleId || report.schoolId || null,
            studentId,
            classId,
            isFuturePlanning: false,
        };

        const requests = keys.length
            ? keys.map((key) => ActivityService.findActivityList({ ...baseBody, key }))
            : [ActivityService.findActivityList(baseBody)];

        const results = await Promise.all(requests);
        return [...new Set(results.flatMap((result) => getActivityNamesFromResponse(result)))];
    };

    const openActivityDialog = async (title, items = [], keys = []) => {
        setActivityDialog({
            open: true,
            title,
            items: items || [],
        });

        if ((items || []).length > 0) {
            return;
        }

        try {
            setIsActivityDialogLoading(true);
            const fetchedItems = await fetchActivityNames(keys);
            setActivityDialog({
                open: true,
                title,
                items: fetchedItems,
            });
        } catch (error) {
            console.error("Error fetching activity names", error);
            setActivityDialog({
                open: true,
                title,
                items: [],
            });
        } finally {
            setIsActivityDialogLoading(false);
        }
    };

    const attendanceTotal = monthWiseAttendance.reduce((sum, row) => sum + (Number(row.totalCount) || 0), 0);
    const totalPresent = monthWiseAttendance.reduce((sum, row) => sum + (Number(row.presentCount) || 0), 0);
    const assignmentPending = Number(studentEvent.notSubmitted) || 0;

    return (
        <Box className={classes.pageContainer}>
            {studentList.length > 1 && (
                <Card className={classes.studentSelectorCard}>
                    <Box style={{ margin: 8 }}>
                        <StudentCards
                            studentList={studentList}
                            onStudentSelect={handleStudentClick}
                            selectedStudentId={selectedStudentId}
                        />
                    </Box>
                </Card>
            )}

            <Typography variant="h5" className={classes.sectionTitle}>
                My Story
            </Typography>

            <Card className={classes.heroCard} elevation={0}>
                <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={8}>
                        <Typography variant="body2" className={classes.introLabel}>
                            Student profile
                        </Typography>
                        <Typography variant="h4" className={classes.heroName}>
                            {selectedStudent?.fullName || "Select a student"}
                        </Typography>

                        <Grid container spacing={2} className={classes.infoGrid}>
                            <Grid item xs={12} sm={6}>
                                <Box className={classes.infoCard}>
                                    <Typography className={classes.infoLabel}>Age</Typography>
                                    <Typography className={classes.infoValue}>
                                        {selectedStudent?.age ?? "-"}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box className={classes.infoCard}>
                                    <Typography className={classes.infoLabel}>Class</Typography>
                                    <Typography className={classes.infoValue}>
                                        {selectedStudent?.classId?.className || "N/A"}
                                        {" / "}
                                        {selectedStudent?.sectionId?.sectionName || "null"}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>

                        <Typography variant="body2" className={classes.heroDescription}>
                            I&apos;m a student at Montessori School, and I love learning through exploring
                            and discovering new things. I was born global, and I&apos;ve always been
                            curious about the world around me, whether it&apos;s how plants grow or how
                            colors mix to make new shades.
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Box className={classes.avatarWrap}>
                            <Avatar
                                src={selectedStudent?.profileURL || selectedStudent?.imageURL?.[0] || "/images/Admin icon.svg"}
                                className={classes.heroAvatar}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Card>

            <Grid container spacing={3} className={classes.statsGrid}>
                <Grid item xs={12} sm={4}>
                    <Box className={classes.statCard}>
                        <Typography className={classes.statLabel}>Attendance Days</Typography>
                        <Typography className={classes.statValue}>{attendanceTotal}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Box className={classes.statCard}>
                        <Typography className={classes.statLabel}>Present Days</Typography>
                        <Typography className={classes.statValue}>{totalPresent}</Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Box className={classes.statCard}>
                        <Typography className={classes.statLabel}>Pending Assignments</Typography>
                        <Typography className={classes.statValue}>{assignmentPending}</Typography>
                    </Box>
                </Grid>
            </Grid>

            <Box className={classes.section}>
                <Box className={classes.sectionCard}>
                    <Typography variant="h6" className={classes.subTitle}>
                        Attendance
                    </Typography>
                    <Paper className={classes.tablePaper} elevation={0}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.headCell} align="center">Month</TableCell>
                                    <TableCell className={classes.headCell} align="center">Present</TableCell>
                                    <TableCell className={classes.headCell} align="center">Absent</TableCell>
                                    <TableCell className={classes.headCell} align="center">Total</TableCell>
                                    <TableCell className={classes.headCell} align="center">Present %</TableCell>
                                    <TableCell className={classes.headCell} align="center">Absent %</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {monthWiseAttendance.length > 0 ? (
                                    monthWiseAttendance.map((row, index) => (
                                        <TableRow key={index} hover>
                                            <TableCell className={classes.bodyCell}>{getMonthName(row._id?.month)} {row._id?.year}</TableCell>
                                            <TableCell align="center" className={classes.bodyCell} style={{ color: "#15803d", fontWeight: 700 }}>
                                                {row.presentCount}
                                            </TableCell>
                                            <TableCell align="center" className={classes.bodyCell} style={{ color: "#dc2626", fontWeight: 700 }}>
                                                {row.absentCount}
                                            </TableCell>
                                            <TableCell align="center" className={classes.bodyCell}>{row.totalCount}</TableCell>
                                            <TableCell align="center" className={classes.bodyCell}>{row.presentPercentage}</TableCell>
                                            <TableCell align="center" className={classes.bodyCell}>{row.absentPercentage}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center" className={classes.emptyState}>
                                            No attendance data available
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Paper>
                </Box>
            </Box>

            <Box className={classes.section}>
                <Box className={classes.sectionCard}>
                    <Typography variant="h6" className={classes.subTitle}>
                        Activity Performance Report
                    </Typography>
                    <Paper className={classes.tablePaper} elevation={0}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.headCell} align="center">Activity</TableCell>
                                    <TableCell className={classes.headCell} align="center">Strong Area</TableCell>
                                    <TableCell className={classes.headCell} align="center">Developing Area</TableCell>
                                    <TableCell className={classes.headCell} align="center">Need Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow hover>
                                    <TableCell align="center" className={classes.bodyCell}>
                                        <span
                                            className={classes.clickableValue}
                                            onClick={() => openActivityDialog("All Activities", activityPerformance.totalActivityNames || [], [])}
                                        >
                                            {activityPerformance.totalActivities || 0}
                                        </span>
                                    </TableCell>
                                    <TableCell align="center" className={classes.bodyCell}>
                                        <span
                                            className={classes.clickableValue}
                                            onClick={() => openActivityDialog("Strong Area Activities", activityPerformance.strongAreaNames || [], ["M", "WI"])}
                                        >
                                            {activityPerformance.strongArea || 0}
                                        </span>
                                    </TableCell>
                                    <TableCell align="center" className={classes.bodyCell}>
                                        <span
                                            className={classes.clickableValue}
                                            onClick={() => openActivityDialog("Developing Area Activities", activityPerformance.developingAreaNames || [], ["WA"])}
                                        >
                                            {activityPerformance.developingArea || 0}
                                        </span>
                                    </TableCell>
                                    <TableCell align="center" className={classes.bodyCell}>
                                        <span
                                            className={classes.clickableValue}
                                            onClick={() => openActivityDialog("Need Action Activities", activityPerformance.needsActionNames || [], ["P"])}
                                        >
                                            {activityPerformance.needsAction || 0}
                                        </span>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>
                </Box>
            </Box>

            <Box className={classes.section}>
                <Box className={classes.sectionCard}>
                    <Typography variant="h6" className={classes.subTitle}>
                        Assignments
                    </Typography>
                    <Paper className={classes.tablePaper} elevation={0}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.headCell} align="center">Number Of Activities</TableCell>
                                    <TableCell className={classes.headCell} align="center">On Time</TableCell>
                                    <TableCell className={classes.headCell} align="center">Delayed</TableCell>
                                    <TableCell className={classes.headCell} align="center">Pending</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow hover>
                                    <TableCell align="center" className={classes.bodyCell}>{studentEvent.total || 0}</TableCell>
                                    <TableCell align="center" className={classes.bodyCell}>{studentEvent.submitted || 0}</TableCell>
                                    <TableCell align="center" className={classes.bodyCell}>{studentEvent.resubmitNotSubmitted || 0}</TableCell>
                                    <TableCell align="center" className={classes.bodyCell}>{studentEvent.notSubmitted || 0}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>
                </Box>
            </Box>

            <Dialog
                open={activityDialog.open}
                onClose={() => setActivityDialog({ open: false, title: "", items: [] })}
                maxWidth="sm"
                fullWidth
                PaperProps={{ className: classes.dialogPaper }}
            >
                <DialogTitle className={classes.dialogTitle}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6">{activityDialog.title}</Typography>
                        <Chip
                            label={`${activityDialog.items.length} Activities`}
                            size="small"
                            style={{ backgroundColor: "#ffffff", color: "#1d4ed8", fontWeight: 700 }}
                        />
                    </Box>
                </DialogTitle>
                <DialogContent className={classes.dialogContent} dividers>
                    <Typography variant="body2" className={classes.dialogSubtitle}>
                        Activity names for the selected performance category.
                    </Typography>
                    {isActivityDialogLoading ? (
                        <Box className={classes.emptyState}>Loading activities...</Box>
                    ) : activityDialog.items.length > 0 ? (
                        <List className={classes.dialogList}>
                            {activityDialog.items.map((item, index) => (
                                <ListItem key={`${item}-${index}`} className={classes.activityItem}>
                                    <Box className={classes.activityIndex}>{index + 1}</Box>
                                    <ListItemText
                                        primary={item}
                                        primaryTypographyProps={{ className: classes.activityName }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    ) : (
                        <Box className={classes.emptyState}>No activities available</Box>
                    )}
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <Button
                        onClick={() => setActivityDialog({ open: false, title: "", items: [] })}
                        color="primary"
                        variant="contained"
                        className={classes.closeButton}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
